import React from "react";
import {
  Document,
  View,
  Page,
  Text,
  PDFDownloadLink,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

import logoVitanova from "../../Images/LogotipoNegro.png";
import CambiarFormatoFechaHelper from "../../Helpers/CambiarFormatoFechaHelper";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: 30,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  image: {
    width: "30%",
    height: "auto",
    textAlign: "center",
    alignSelf: "center",
  },
  titulo: {
    fontSize: 12,
    marginTop: 30,
    textAlign: "center",
  },
  tituloNombre: {
    fontSize: 12,
    marginTop: 10,
    textAlign: "center",
  },
  firmaConformidad: {
    fontSize: 10,
    marginTop: 200,
    textAlign: "center",
  },
  textoFirmaConformidad: {
    fontSize: 10,
    textAlign: "center",
  },
  table: {
    display: "table",
    width: "100%",
    marginBottom: 10,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 8,
    fontWeight: "bold",
    borderBottomColor: "#000",
    borderBottomWidth: 1,
    textAlign: "center",
    width: "12.5%",
  },
  tableCell: {
    margin: 5,
    fontSize: 7,
    textAlign: "center",
    width: "12.5%",
  },
});

export const ImprimirPdfComponentPrevisionDetalle = (props) => {
  const generatePDF = () => (
    <>
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <Image style={styles.image} src={logoVitanova} />
            <Text style={styles.titulo}>
              Listado de comisiones del día: {props.fechaInicio} al{" "}
              {props.fechaFin}
            </Text>
            <Text style={styles.tituloNombre}>
              Nombre: {props.nombreEmpleadoSeleccionado}
            </Text>
          </View>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text style={styles.tableCellHeader}>Contrato</Text>
              <Text style={styles.tableCellHeader}>Fecha Pago</Text>
              <Text style={styles.tableCellHeader}>Nombre Titular 1</Text>
              <Text style={styles.tableCellHeader}>Comisión</Text>
              <Text style={styles.tableCellHeader}>Pagado</Text>
              <Text style={styles.tableCellHeader}>Por pagar</Text>
            </View>

            {props.data.map((recibo, index) => (
              <View key={index} style={styles.tableRow}>
                <Text style={styles.tableCell}>{recibo.noContrato}</Text>
                <Text style={styles.tableCell}>
                  {CambiarFormatoFechaHelper(recibo.ultimoPago)}
                </Text>
                <Text style={styles.tableCell}>{recibo.titular1}</Text>
                <Text style={styles.tableCell}>
                  {" "}
                  {"$ "}
                  {parseFloat(recibo.Comision)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                </Text>
                <Text style={styles.tableCell}>
                  {" "}
                  {"$ "}
                  {parseFloat(recibo.pagado)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                </Text>
                <Text style={styles.tableCell}>
                  {" "}
                  {"$ "}
                  {parseFloat(recibo.porPagar)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                </Text>
              </View>
            ))}

            <View style={styles.tableRow}>
              <Text style={styles.tableCell}>{"Total"}</Text>
              <Text style={styles.tableCell}>{""}</Text>
              <Text style={styles.tableCell}>{""}</Text>
              <Text style={styles.tableCell}>{""}</Text>

              <Text style={styles.tableCell}>{""}</Text>
              <Text style={styles.tableCell}>
                {" "}
                {"$ "}
                {parseFloat(
                  props.data.reduce((acumulador, producto) => {
                    return acumulador + parseFloat(producto.porPagar);
                  }, 0)
                )
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
              </Text>
            </View>
          </View>
        </Page>
      </Document>
    </>
  );

  return (
    <div>
      <PDFDownloadLink
        document={generatePDF()}
        fileName={`Comisiones_OS_${props.fechaInicio}_${props.fechaFin}.pdf`}
      >
        {({ blob, url, loading, error }) =>
          loading ? (
            "Cargando documento..."
          ) : (
            <div className="btn btn-sm btn-danger mt-3">Descargar PDF</div>
          )
        }
      </PDFDownloadLink>
    </div>
  );
};
